import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export default function StickyCallBar() {
  return (
    <motion.a
      data-testid="sticky-call-bar"
      href="tel:0410514499"
      aria-label="Call Craig"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
      whileTap={{ scale: 0.9 }}
      className="md:hidden fixed bottom-5 right-5 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-ember text-coal shadow-[0_8px_30px_rgba(252,153,7,0.35)] active:bg-ember-dark"
    >
      <Phone size={20} strokeWidth={2} />
    </motion.a>
  );
}
